var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "alert-dialog" }, [
        _c(
          "div",
          { staticClass: "alert-dialog-content" },
          [_vm._t("default")],
          2
        ),
        _c("button", { staticClass: "button", on: { click: _vm.close } }, [
          _vm._v("关闭"),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }